export function embedVideo() {
  var getId = function(el, data) {
    return el.getAttribute(data);
  };

  var getPosterURL = function(el) {
    return (
      'https://img.youtube.com/vi/' + getId(el, 'data-embed') + '/sddefault.jpg'
    );
  };

  var getEmbedURL = function(el) {
    return (
      'https://www.youtube.com/embed/' +
      getId(el, 'data-embed') +
      '?rel=0&showinfo=0&autoplay=1'
    );
  };

  var createIframe = function(e) {
    console.log(e);
    var currentTarget = e.currentTarget;
    var iframe = document.createElement('iframe');

    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('src', getEmbedURL(currentTarget));

    this.innerHTML = '';
    this.appendChild(iframe);
  };

  var addCover = function(video) {
    var source = getPosterURL(video);
    var image = new Image();

    image.src = source;
    image.setAttribute('class', 'embed-video__poster');

    image.addEventListener(
      'load',
      (function() {
        video.appendChild(image);
      })(video),
    );
  };

  var init = function(videos) {
    videos.forEach(function(video) {
      console.log(videos);
      video.addEventListener('click', createIframe);
    });
  };

  return {
    init: init,
  };
}
